import * as React from 'react';
import Button from '@mui/material/Button';
import cn from 'classnames';

import { useTheme } from '../../../../theme';
import { BackwardButtonProps } from '../../types';
import { CdnIcon } from '@shared/ui';

const BackwardButton: React.FC<BackwardButtonProps> = ({
	classes,
	variant = 'icon',
	disableElevation = true,
	text = 'GoBack',
	...restProps
}) => {
	const { BackwardButton: theme } = useTheme('BaseComponents') || {};

	return (
		<Button
			variant={'text'}
			classes={{
				...classes,
				root: cn(theme.root, theme[variant], classes?.root)
			}}
			disableElevation={disableElevation}
			{...restProps}
		>
			{(variant === 'icon' || variant === 'both') && (
				<CdnIcon className={theme.arrowBackIcon} icon="Arrow/Back" />
			)}
			{(variant === 'text' || variant === 'both') && text && <div className={theme.arrowBackText}>{text}</div>}
		</Button>
	);
};

export default BackwardButton;
